const SDK_VERSION = '7.36.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
